const originURL = 'https://scale.ai';

type QueryParams = { [key: string]: string | null };

export const getAsPath = (asPath: string, newQueryParams: QueryParams, override = true) => {
  const uri = new URL(asPath, originURL);

  Object.keys(newQueryParams).forEach(key => {
    const value = newQueryParams[key];
    if (value === null) {
      if (override) uri.searchParams.delete(key);
      return;
    }
    if (uri.searchParams.has(key) && override) {
      uri.searchParams.delete(key);
    }
    uri.searchParams.append(key, value);
  });

  return `${uri.pathname}${uri.search}`;
};
